export class ShelfDirection {
    ID?: number;
    Name?: string;
}

export default ShelfDirection;